import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "col-xxl-12" }
const _hoisted_2 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_3 = { class: "card-body pt-9 pb-0" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "card-body py-3" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "card-header border-0 pt-5" }, [
  /*#__PURE__*/_createVNode("h3", { class: "card-title align-items-start flex-column" }, [
    /*#__PURE__*/_createVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, " Monthly Prime Rank For This Year ")
  ])
], -1)
const _hoisted_7 = { class: "card-body py-3 col-md-12" }
const _hoisted_8 = { class: "table-responsive" }
const _hoisted_9 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_10 = { class: "fw-bolder text-muted bg-light" }
const _hoisted_11 = {
  key: 0,
  class: "material-icons",
  style: {"color":"green"}
}
const _hoisted_12 = {
  key: 0,
  class: "material-icons",
  style: {"color":"red"}
}
const _hoisted_13 = { class: "card-body py-3" }
const _hoisted_14 = { class: "row col-md-12" }
const _hoisted_15 = { class: "col-md-6" }
const _hoisted_16 = {
  key: 0,
  class: "row",
  align: ""
}
const _hoisted_17 = { class: "col-md-12" }
const _hoisted_18 = { class: "m-t-5" }
const _hoisted_19 = {
  key: 1,
  class: "row",
  align: ""
}
const _hoisted_20 = { class: "col-md-12" }
const _hoisted_21 = { class: "m-t-5" }
const _hoisted_22 = {
  class: "row",
  align: ""
}
const _hoisted_23 = /*#__PURE__*/_createVNode("div", { class: "col-md-1" }, null, -1)
const _hoisted_24 = { class: "col-md-1" }
const _hoisted_25 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_26 = /*#__PURE__*/_createVNode("i", {
  class: "material-icons",
  style: {"color":"green"}
}, "check_circle", -1)
const _hoisted_27 = {
  key: 1,
  class: "mt-4"
}
const _hoisted_28 = /*#__PURE__*/_createVNode("i", {
  class: "material-icons",
  style: {"color":"red"}
}, "cancel", -1)
const _hoisted_29 = /*#__PURE__*/_createVNode("div", { class: "col-md-10" }, [
  /*#__PURE__*/_createVNode("h6", { class: "mt-5 dashboardFontSTyle" }, "Total prime requirements achieved.")
], -1)
const _hoisted_30 = {
  class: "row",
  align: ""
}
const _hoisted_31 = /*#__PURE__*/_createVNode("div", { class: "col-md-1" }, null, -1)
const _hoisted_32 = { class: "col-md-1" }
const _hoisted_33 = {
  key: 0,
  class: "mt-4 dashboardFontStyle"
}
const _hoisted_34 = /*#__PURE__*/_createVNode("i", {
  class: "material-icons",
  style: {"color":"green"}
}, "check_circle", -1)
const _hoisted_35 = {
  key: 1,
  class: "mt-7 dashboardFontStyle"
}
const _hoisted_36 = /*#__PURE__*/_createVNode("i", {
  class: "material-icons ",
  style: {"color":"red"}
}, "cancel", -1)
const _hoisted_37 = { class: "col-md-10" }
const _hoisted_38 = /*#__PURE__*/_createVNode("h6", { class: "mt-5 dashboardFontStyle" }, "Personal Consumption Done (PMA/PC)", -1)
const _hoisted_39 = {
  key: 0,
  class: "dashboardFontStyle prime_monitoring_cta"
}
const _hoisted_40 = {
  class: "row",
  align: ""
}
const _hoisted_41 = /*#__PURE__*/_createVNode("div", { class: "col-md-1" }, null, -1)
const _hoisted_42 = { class: "col-md-1" }
const _hoisted_43 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_44 = /*#__PURE__*/_createVNode("i", {
  class: "material-icons",
  style: {"color":"green"}
}, "check_circle", -1)
const _hoisted_45 = {
  key: 1,
  class: "mt-7"
}
const _hoisted_46 = /*#__PURE__*/_createVNode("i", {
  class: "material-icons ",
  style: {"color":"red"}
}, "cancel", -1)
const _hoisted_47 = { class: "col-md-10" }
const _hoisted_48 = /*#__PURE__*/_createVNode("h6", { class: "mt-5 dashboardFontStyle" }, "Most Active Line Must Produce At Least 1 Point", -1)
const _hoisted_49 = {
  key: 0,
  class: "dashboardFontStyle prime_monitoring_cta"
}
const _hoisted_50 = {
  class: "row",
  align: ""
}
const _hoisted_51 = /*#__PURE__*/_createVNode("div", { class: "col-md-1" }, null, -1)
const _hoisted_52 = { class: "col-md-1" }
const _hoisted_53 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_54 = /*#__PURE__*/_createVNode("i", {
  class: "material-icons",
  style: {"color":"green"}
}, "check_circle", -1)
const _hoisted_55 = {
  key: 1,
  class: "mt-7"
}
const _hoisted_56 = /*#__PURE__*/_createVNode("i", {
  class: "material-icons",
  style: {"color":"red"}
}, "cancel", -1)
const _hoisted_57 = { class: "col-md-10" }
const _hoisted_58 = /*#__PURE__*/_createVNode("h6", { class: "mt-5 dashboardFontStyle" }, "Minimum of 2 Moving Legs / Directs", -1)
const _hoisted_59 = {
  key: 0,
  class: "dashboardFontStyle prime_monitoring_cta"
}
const _hoisted_60 = {
  class: "row",
  align: ""
}
const _hoisted_61 = /*#__PURE__*/_createVNode("div", { class: "col-md-1" }, null, -1)
const _hoisted_62 = { class: "col-md-1" }
const _hoisted_63 = {
  key: 0,
  class: "mt-4 dashboardFontStyle"
}
const _hoisted_64 = /*#__PURE__*/_createVNode("i", {
  class: "material-icons",
  style: {"color":"green"}
}, "check_circle", -1)
const _hoisted_65 = {
  key: 1,
  class: "mt-7 dashboardFontStyle"
}
const _hoisted_66 = /*#__PURE__*/_createVNode("i", {
  class: "material-icons ",
  style: {"color":"red"}
}, "cancel", -1)
const _hoisted_67 = { class: "col-md-10" }
const _hoisted_68 = /*#__PURE__*/_createVNode("h6", { class: "mt-5 dashboardFontStyle" }, "10% Of The Total Monthly Production Coming From The Other Legs/ Directs.", -1)
const _hoisted_69 = {
  key: 0,
  class: "dashboardFontStyle prime_monitoring_cta"
}
const _hoisted_70 = { class: "col-md-6" }
const _hoisted_71 = {
  class: "row",
  align: "center"
}
const _hoisted_72 = { class: "table-responsive" }
const _hoisted_73 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_74 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createVNode("th", { class: "ps-4 min-w-125px rounded-start" }, "USID"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-200px" }, "NAME"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-105px" }, "POINTS")
  ])
], -1)
const _hoisted_75 = /*#__PURE__*/_createVNode("div", { class: "row col-md-12" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_ECP_EDP_DashboardNavigator = _resolveComponent("ECP_EDP_DashboardNavigator")
  const _component_font = _resolveComponent("font")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_el_skeleton, {
        rows: 20,
        animated: ""
      })
    ], 512), [
      [_vShow, _ctx.isLoading]
    ]),
    _withDirectives(_createVNode("div", _hoisted_1, [
      _createVNode("div", {
        class: [_ctx.widgetClasses, "card"]
      }, [
        (_ctx.pt != 'ovi')
          ? (_openBlock(), _createBlock("div", _hoisted_2, [
              _createVNode("div", _hoisted_3, [
                _createVNode(_component_ECP_EDP_DashboardNavigator)
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode("div", _hoisted_7, [
              _createVNode("div", _hoisted_8, [
                _createVNode("table", _hoisted_9, [
                  _createVNode("thead", null, [
                    _createVNode("tr", _hoisted_10, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.rankPrimeOneYear, (item, index) => {
                        return (_openBlock(), _createBlock("th", {
                          key: index,
                          class: "ps-4 min-w-125px "
                        }, _toDisplayString(item.month_abbrev), 1))
                      }), 128))
                    ])
                  ]),
                  _createVNode("tbody", null, [
                    _createVNode("tr", null, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.rankPrimeOneYear, (item, index) => {
                        return (_openBlock(), _createBlock("td", {
                          key: index,
                          class: "ps-4 min-w-125px "
                        }, [
                          (item.primeRank != '')
                            ? (_openBlock(), _createBlock("i", _hoisted_11, "check_circle"))
                            : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                                (item.ispast == 1)
                                  ? (_openBlock(), _createBlock("i", _hoisted_12, "cancel"))
                                  : _createCommentVNode("", true)
                              ], 64))
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_13, [
          _createVNode("div", _hoisted_14, [
            _createVNode("div", _hoisted_15, [
              (_ctx.pm.isQualifiedPrimeNextMonth == 1)
                ? (_openBlock(), _createBlock("div", _hoisted_16, [
                    _createVNode("div", _hoisted_17, [
                      _createVNode("h4", _hoisted_18, [
                        _createVNode(_component_font, { color: "green" }, {
                          default: _withCtx(() => [
                            _createTextVNode("As Of Now, You Are Qualified For The Prime Position For The Month Of " + _toDisplayString(_ctx.nextMonth) + ". Keep It Up!", 1)
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.pm.isQualifiedPrimeNextMonth != 1)
                ? (_openBlock(), _createBlock("div", _hoisted_19, [
                    _createVNode("div", _hoisted_20, [
                      _createVNode("h4", _hoisted_21, [
                        _createVNode(_component_font, { color: "red" }, {
                          default: _withCtx(() => [
                            _createTextVNode("You are not yet qualified for the month of " + _toDisplayString(_ctx.nextMonth) + ".", 1)
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_22, [
                _hoisted_23,
                _createVNode("div", _hoisted_24, [
                  (_ctx.pm.isQualifiedPrimeNextMonth === 1)
                    ? (_openBlock(), _createBlock("h6", _hoisted_25, [
                        _hoisted_26
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.pm.isQualifiedPrimeNextMonth !== 1)
                    ? (_openBlock(), _createBlock("h6", _hoisted_27, [
                        _hoisted_28
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_29
              ]),
              _createVNode("div", _hoisted_30, [
                _hoisted_31,
                _createVNode("div", _hoisted_32, [
                  (_ctx.pm.primeMonitoring_isPMA === 1)
                    ? (_openBlock(), _createBlock("h6", _hoisted_33, [
                        _hoisted_34
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.pm.primeMonitoring_isPMA !== 1)
                    ? (_openBlock(), _createBlock("h6", _hoisted_35, [
                        _hoisted_36
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_37, [
                  _hoisted_38,
                  (_ctx.pm.primeMonitoring_isPMA !== 1)
                    ? (_openBlock(), _createBlock("p", _hoisted_39, "Buy and avail for your personal consumption products."))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode("div", _hoisted_40, [
                _hoisted_41,
                _createVNode("div", _hoisted_42, [
                  (_ctx.pm.loop_topLeg_totalPoints >= 1.00)
                    ? (_openBlock(), _createBlock("h6", _hoisted_43, [
                        _hoisted_44
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.pm.loop_topLeg_totalPoints < 1.00)
                    ? (_openBlock(), _createBlock("h6", _hoisted_45, [
                        _hoisted_46
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_47, [
                  _hoisted_48,
                  (_ctx.pm.loop_topLeg_totalPoints < 1.00)
                    ? (_openBlock(), _createBlock("p", _hoisted_49, "Remind and encourage your other producing legs to buy and consume our products."))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode("div", _hoisted_50, [
                _hoisted_51,
                _createVNode("div", _hoisted_52, [
                  (_ctx.pm.primeMonitoringSize >= 2)
                    ? (_openBlock(), _createBlock("h6", _hoisted_53, [
                        _hoisted_54
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.pm.primeMonitoringSize < 2)
                    ? (_openBlock(), _createBlock("h6", _hoisted_55, [
                        _hoisted_56
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_57, [
                  _hoisted_58,
                  (_ctx.pm.primeMonitoringSize < 2)
                    ? (_openBlock(), _createBlock("p", _hoisted_59, "Remind and encourage your other producing legs to buy and consume our products."))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode("div", _hoisted_60, [
                _hoisted_61,
                _createVNode("div", _hoisted_62, [
                  (_ctx.pm.primeMonitoring_isOK == 1)
                    ? (_openBlock(), _createBlock("h6", _hoisted_63, [
                        _createVNode(_component_font, { color: "green" }, {
                          default: _withCtx(() => [
                            _hoisted_64
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.pm.primeMonitoring_isOK != 1)
                    ? (_openBlock(), _createBlock("h6", _hoisted_65, [
                        _createVNode(_component_font, { color: "red" }, {
                          default: _withCtx(() => [
                            _hoisted_66
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_67, [
                  _hoisted_68,
                  (_ctx.pm.primeMonitoring_isOK != 1)
                    ? (_openBlock(), _createBlock("p", _hoisted_69, "Remind and encourage your other producing legs to buy and consume our products."))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createVNode("div", _hoisted_70, [
              _createVNode("div", _hoisted_71, [
                _createVNode("div", _hoisted_72, [
                  _createVNode("table", _hoisted_73, [
                    _hoisted_74,
                    _createVNode("tbody", null, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.pm.primeMonitoring, (item, index) => {
                        return (_openBlock(), _createBlock("tr", { key: index }, [
                          _createVNode("td", null, "   " + _toDisplayString(item.usid), 1),
                          _createVNode("td", null, _toDisplayString(item.fullname), 1),
                          _createVNode("td", null, _toDisplayString(_ctx.numberWithCommas(item.totalpoints)), 1)
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _hoisted_75
        ])
      ], 2)
    ], 512), [
      [_vShow, _ctx.isLoading == false]
    ])
  ], 64))
}